import { render } from "./Resource.vue?vue&type=template&id=1dc56b7c"
import script from "./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue?vue&type=script&lang=js"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__